import React, { useEffect } from "react";
import AuthStore from "../../stores/AuthStore";
import { message } from "antd";
import { useNavigate } from "react-router";

const systemKey = window.CONFIG.systemKey;
const tokenKey = `${systemKey}-token`;

const ContainerLoginPage: React.FC = (props) => {
  const navigate = useNavigate();

  useEffect(() => {
    try {
      AuthStore.ssoLoginDingContainer()
        .then(() => {
          navigate("/client/userInfo/getUserInfo?token=" + localStorage.getItem(tokenKey));
          // alert(localStorage.getItem("token"));
          // navigate("/");
        })
        .catch(() => {
          message.error("登录失败，跳转至登录页");
          navigate("/sso/login");
        });
    } catch (e) {
      console.log(e);
    }
  }, []);

  return <div>认证中...</div>;
};

export default ContainerLoginPage;
